export default __webpack_public_path__ + "static/l1-cta-oval-6498c920205548d098c1e8262993a91c.png";